import { UniqueIdentifier } from '@dnd-kit/core'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import clsx from 'clsx'
import { motion } from 'motion/react'
import { HTMLAttributes, useState } from 'react'
import styles from './AttachmentSortContainer.module.css'

export default function AttachmentSortContainer({
	children,
	className,
	...props
}: HTMLAttributes<HTMLDivElement>) {
	const [isHover, setIsHover] = useState<boolean>(false)
	const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition } =
		useSortable({
			id: props.id as UniqueIdentifier,
		})

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
	}

	const renderDragHandler = () => (
		<motion.div
			ref={setActivatorNodeRef}
			{...listeners}
			style={{
				top: -4,
				left: '50%',
				x: '-50%',
				transformOrigin: 'top center',
			}}
			initial={{
				opacity: 0,
				scale: 0.6,
			}}
			animate={{
				opacity: isHover ? 1 : 0,
				scale: isHover ? 1 : 0.6,
				transition: {
					type: 'spring',
					damping: 20,
					stiffness: 200,
				},
			}}
			whileHover={{
				scale: 1.05,
			}}
			className={styles.dragHandler}
		/>
	)

	return (
		<div
			onMouseOver={() => void setIsHover(true)}
			onMouseLeave={() => void setIsHover(false)}
			ref={setNodeRef}
			style={style}
			{...attributes}
			{...props}
			className={clsx(styles.root, className)}
		>
			{renderDragHandler()}
			{children}
		</div>
	)
}
